const WaiverFooter = ({ waiver }) => {

    if (!waiver) return null;

    return (
    <div className="bg-white border rounded-xl p-5 mt-6">

        <div className="grid grid-cols-3 gap-6">

          <div>
            <div className="text-xs text-muted-foreground mb-1">
              Waiver ID (UUID)
            </div>

            <div>{waiver._id}</div>
          </div>

          <div>
            <div className="text-xs text-muted-foreground mb-1">
              Viewer Timezone
            </div>

            <div>{Intl.DateTimeFormat().resolvedOptions().timeZone}</div>
          </div>

          <div>
            <div className="text-xs text-muted-foreground mb-1">
              Record Retention
            </div>

            <div>
              Signed records are retained permanently
              for audit and legal compliance.
            </div>
          </div>

        </div>

     </div>
  );
};

export default WaiverFooter;